export const GRID_TOKEN_DECIMALS = 12;
export const PHONON_TOKEN_DECIMALS = 18;
export const PHONON_PER_GRID = 155;
